import fileSys from "../../fileoprators/fileSystem";
import { INVALID_1000 } from "../../topography/shared";

let _ratioX;
let _ratioY;
const COLORS = { green: "#00ff00", gray: "#808080", red: "#ff0000" };
const CONFIG = {
  lineLength: 300,
  lineOffset: 0,
  lineWidth: 8,
  lineWidth_FB: 10,
  arcRadius: 80,
  arc_FB: 20,
  threshold: 3,
  lineWidth_Cross: 3
};
const isDef = (v) => {
  return v !== null && v !== undefined;
};
const isValid = (v) => {
  return isDef(v) && Math.abs(v - INVALID_1000) > 0.0001;
};
const getArc = (angle) => {
  return (angle / 180.0) * Math.PI;
};
function draw(canvas, calP, shotcfg) {
  if (!canvas) return;
  let context = canvas.getContext("2d");
  if (!context) return;
  // let ratio = 1 // 1360.0 / 1024.0
  _ratioX = canvas.width / 1024.0;
  _ratioY = canvas.height / 768.0;
  context.fillStyle = "rgba(255, 255, 255, 0)";
  if (calP && calP.xy && calP.z && shotcfg) {
    drawCTCenter(context, calP.xy, calP.z, shotcfg);
  }
  if (calP && calP.offset && shotcfg) {
    drawCTDirs(context, calP.offset, shotcfg);
  }
}
function drawCTCenter(cxt, xypos, zpos, shotcfg) {
  cxt.strokeStyle = shotcfg.CTCenter.fillColor;
  let dxy = {
    x: xypos.x - shotcfg.centerPoint.x,
    y: xypos.y - shotcfg.centerPoint.y
  };
  if (
    dxy.x >= shotcfg.handleZ.offsetX * -1 &&
    dxy.x <= shotcfg.handleZ.offsetX &&
    dxy.y >= shotcfg.handleZ.offsetY * -1 &&
    dxy.y <= shotcfg.handleZ.offsetY
  ) {
    if (zpos && isNumber(zpos.x) && isNumber(zpos.y)) {
      cxt.fillStyle = shotcfg.CTCenter.lineColor;
      let x = zpos.x * _ratioX;
      let y = zpos.y * _ratioY;
      let len = shotcfg.CTCenter.len;
      cxt.beginPath();
      cxt.arc(x, y, len, 0, Math.PI * 2);
      // cxt.stroke()
      cxt.fill();
    }
  }
  cxt.closePath();
}

const getColor = (offset, threshold, green, flag = 1) => {
  if (green) {
    return COLORS.green;
  }
  if (!isValid(offset) || !isValid(threshold)) {
    return COLORS.gray;
  }
  // console.log(offset, threshold, flag)
  if (flag === 1) {
    if (offset > threshold * flag) {
      return COLORS.red;
    }
  } else if (offset < threshold * flag) {
    return COLORS.red;
  }
  return COLORS.gray;
};
function drawCTDirs(ctx, offset, shotcfg = {}) {
  const { autoShot, centerPoint } = shotcfg;
  if (!centerPoint) return;
  const center = { x: centerPoint.x * _ratioX || 1, y: centerPoint.y * _ratioY || 1 }; // 校准中心点
  ctx.translate(center.x, center.y);
  let green = true;
  if (isDef(offset) && isDef(autoShot)) {
    ["x", "y", "z"].forEach((key) => {
      if (!isValid(offset[key]) || Math.abs(offset[key]) > autoShot[`offset${key.toUpperCase()}`]) {
        green = false;
      }
    });
  } else {
    green = false;
  }
  drawLeft(ctx, offset.x, autoShot.offsetX, green);
  drawRight(ctx, offset.x, autoShot.offsetX, green);
  if (!green) {
    drawUp(ctx, offset.y, autoShot.offsetY, green);
    drawDown(ctx, offset.y, autoShot.offsetY, green);
  } else {
    drawCircle(ctx);
  }
  drawFront(ctx, offset.z, autoShot.offsetZ, green);
  drawBack(ctx, offset.z, autoShot.offsetZ, green);
}

function drawArrow(ctx, start, end, arrowD, arrowS) {
  let distanceX = end.x - start.x;
  let distanceY = end.y - start.y;
  let distance = Math.sqrt(distanceY * distanceY + distanceX * distanceX);
  let distanceArrow = arrowD || 30;
  let sharpeArrow = arrowS || 20;
  // 先确定轴线与三角两个尖角点交汇坐标
  let arrowMoveTo = {
    x: start.x + (distanceArrow * distanceX) / distance,
    y: start.y + (distanceArrow * distanceY) / distance
  };
  let arrowLineTo = {
    x: end.x - (distanceArrow * distanceX) / distance,
    y: end.y - (distanceArrow * distanceY) / distance
  };
  // 4个对称点坐标
  let arrowTo1 = {
    x: arrowMoveTo.x - (sharpeArrow * distanceY) / distance,
    y: arrowMoveTo.y + (sharpeArrow * distanceX) / distance
  };
  let arrowTo2 = {
    x: arrowMoveTo.x + (sharpeArrow * distanceY) / distance,
    y: arrowMoveTo.y - (sharpeArrow * distanceX) / distance
  };
  let arrowTo3 = {
    x: arrowLineTo.x - (sharpeArrow * distanceY) / distance,
    y: arrowLineTo.y + (sharpeArrow * distanceX) / distance
  };
  let arrowTo4 = {
    x: arrowLineTo.x + (sharpeArrow * distanceY) / distance,
    y: arrowLineTo.y - (sharpeArrow * distanceX) / distance
  };
  // 设置线的粗细和断点，转角样式
  ctx.lineJoin = "round";
  ctx.strokeStyle = COLORS.red;
  ctx.fillStyle = COLORS.red;
  // 绘制方法
  ctx.beginPath();
  ctx.moveTo(start.x, start.y);
  ctx.lineTo(end.x, end.y);
  ctx.lineTo(arrowTo3.x, arrowTo3.y);
  ctx.lineTo(arrowTo4.x, arrowTo4.y);
  ctx.lineTo(end.x, end.y);
  ctx.closePath();
  ctx.stroke();
  ctx.fill();
}
const drawLeft = (ctx, offset, threshold, green) => {
  ctx.beginPath();
  ctx.lineWidth = CONFIG.lineWidth;
  ctx.strokeStyle = getColor(offset, threshold, green, -1);
  ctx.moveTo(
    -CONFIG.lineLength / 2 - CONFIG.lineOffset + (1 / 2) * CONFIG.lineWidth,
    -CONFIG.lineLength / 2
  );
  ctx.lineTo(
    -CONFIG.lineLength / 2 - CONFIG.lineOffset + (1 / 2) * CONFIG.lineWidth,
    CONFIG.lineLength / 2
  );
  ctx.stroke();
  let start = {
    x: -CONFIG.lineLength / 2 - CONFIG.lineOffset,
    y: 0
  };
  let end = {
    x: (-CONFIG.lineLength / 2) * 2,
    y: 0
  };
  if (ctx.strokeStyle === COLORS.red) drawArrow(ctx, start, end);
  return ctx.strokeStyle;
};
const drawUp = (ctx, offset, threshold, green) => {
  ctx.strokeStyle = getColor(offset, threshold, green, -1);
  // console.log(ctx.strokeStyle)
  if (ctx.strokeStyle === COLORS.gray) return ctx.strokeStyle;
  ctx.beginPath();
  ctx.arc(0, 0, CONFIG.arcRadius, getArc(0), getArc(270));
  ctx.stroke();
  let start = {
    x: 0,
    y: -CONFIG.arcRadius
  };
  let end = {
    x: 10,
    y: -CONFIG.arcRadius
  };
  drawArrow(ctx, start, end, 15, 15);
  return ctx.strokeStyle;
};
const drawDown = (ctx, offset, threshold, green) => {
  ctx.strokeStyle = getColor(offset, threshold, green, 1);
  if (ctx.strokeStyle === COLORS.gray) return ctx.strokeStyle;
  ctx.beginPath();
  ctx.arc(0, 0, CONFIG.arcRadius, getArc(180), getArc(270), true);
  ctx.stroke();
  let start = {
    x: 10,
    y: -CONFIG.arcRadius
  };
  let end = {
    x: 0,
    y: -CONFIG.arcRadius
  };
  drawArrow(ctx, start, end, 15, 15);
  return ctx.strokeStyle;
};
const drawCircle = (ctx) => {
  ctx.beginPath();
  ctx.strokeStyle = COLORS.green;
  ctx.arc(0, 0, CONFIG.arcRadius, 0, Math.PI * 2);
  ctx.stroke();
};

const drawRight = (ctx, offset, threshold, green) => {
  // console.log('draw-left-arc')
  ctx.beginPath();
  ctx.lineWidth = CONFIG.lineWidth;
  ctx.strokeStyle = getColor(offset, threshold, green, 1);
  ctx.moveTo(
    CONFIG.lineLength / 2 + CONFIG.lineOffset - (1 / 2) * CONFIG.lineWidth,
    -CONFIG.lineLength / 2
  );
  ctx.lineTo(
    CONFIG.lineLength / 2 + CONFIG.lineOffset - (1 / 2) * CONFIG.lineWidth,
    CONFIG.lineLength / 2
  );
  ctx.stroke();
  let start = {
    x: CONFIG.lineLength / 2 + CONFIG.lineOffset,
    y: 0
  };
  let end = {
    x: (CONFIG.lineLength / 2) * 2,
    y: 0
  };
  if (ctx.strokeStyle === COLORS.red) drawArrow(ctx, start, end);
  return ctx.strokeStyle;
};
const drawFront = (ctx, offset, threshold, green) => {
  ctx.beginPath();
  ctx.lineWidth = CONFIG.lineWidth;
  ctx.strokeStyle = getColor(
    offset,
    threshold,
    green,
    window.ctShotInfo.shotMode === "far" ? -1 : 1
  );
  ctx.moveTo(
    -CONFIG.lineLength / 2,
    -CONFIG.lineLength / 2 - CONFIG.lineOffset + (1 / 2) * CONFIG.lineWidth
  );
  ctx.lineTo(
    CONFIG.lineLength / 2,
    -CONFIG.lineLength / 2 - CONFIG.lineOffset + (1 / 2) * CONFIG.lineWidth
  );
  ctx.stroke();
  let start = {
    x: 0,
    y: -CONFIG.lineLength / 2 - CONFIG.lineOffset
  };
  let end = {
    x: 0,
    y: (-CONFIG.lineLength / 2) * 2
  };
  if (ctx.strokeStyle === COLORS.red) drawArrow(ctx, start, end);
  return ctx.strokeStyle;
};

const drawBack = (ctx, offset, threshold, green) => {
  // console.log('draw-left-arc')
  ctx.beginPath();
  ctx.lineWidth = CONFIG.lineWidth;
  ctx.strokeStyle = getColor(
    offset,
    threshold,
    green,
    window.ctShotInfo.shotMode === "far" ? 1 : -1
  );
  ctx.moveTo(
    -CONFIG.lineLength / 2,
    CONFIG.lineLength / 2 + CONFIG.lineOffset - (1 / 2) * CONFIG.lineWidth
  );
  ctx.lineTo(
    CONFIG.lineLength / 2,
    CONFIG.lineLength / 2 + CONFIG.lineOffset - (1 / 2) * CONFIG.lineWidth
  );
  ctx.stroke();
  let start = {
    x: 0,
    y: CONFIG.lineLength / 2 + CONFIG.lineOffset
  };
  let end = {
    x: 0,
    y: (CONFIG.lineLength / 2) * 2
  };
  if (ctx.strokeStyle === COLORS.red) drawArrow(ctx, start, end);
  return ctx.strokeStyle;
};
// true:数值型的，false：非数值型
function isNumber(value) {
  return typeof value === "number" && !isNaN(value);
}

export default {
  draw
};



// WEBPACK FOOTER //
// ./src/mainInterface/js/DrawCTCal.js